import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { errorViewerDialogStyles } from './errorViewerDialogStyles';

interface ErrorViewerDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  errorSource: string;
  errorType: string;
  errorMessage: string;
}

const ErrorViewerDialog: React.FC<ErrorViewerDialogProps> = ({
  open,
  onClose,
  title,
  errorSource,
  errorType,
  errorMessage,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={errorViewerDialogStyles.dialog}
    >
      <DialogTitle sx={errorViewerDialogStyles.title}>
        <Box sx={errorViewerDialogStyles.box}>
          <InfoOutlinedIcon fontSize="small" />
          <Typography variant="h6">{title}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={errorViewerDialogStyles.content}>
        <Typography variant="body2">
          <Box component="span" sx={errorViewerDialogStyles.contentSpan}>
            Source:
          </Box>
          {errorSource}
        </Typography>
        <Typography variant="body2">
          <Box component="span" sx={errorViewerDialogStyles.contentSpan}>
            Type:
          </Box>
          {errorType}
        </Typography>
        <Typography variant="body2">
          <Box component="span" sx={errorViewerDialogStyles.contentSpan}>
            Message:
          </Box>
          {errorMessage}
        </Typography>
      </DialogContent>
      <DialogActions sx={errorViewerDialogStyles.action}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorViewerDialog;
